import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AssetDepreciationTranslations  {
    _originalTypeClassName = "zERP.BO.AssetDepreciationTranslations";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AssetDepreciationTranslations.translate = translateService;
}
this.AssetDepreciationTranslationsKey = null;
this._key = this.AssetDepreciationTranslationsKey = 0; 
}

static translate: TranslateService;
_key: any;
private _AssetDepreciationTranslationsKey:any;
get AssetDepreciationTranslationsKey(): any {
    return this._AssetDepreciationTranslationsKey;
  }
set AssetDepreciationTranslationsKey(value: any) {
    this._AssetDepreciationTranslationsKey = value;
    this._key = value;
  }

static DepreciationBase(assetBase: any): any{switch ((assetBase)) {case Domain.AssetDepreciationType.TaxBase:
{
return this.translate.instant('Res_ENUM_AssetDepreciationType_TaxBase');}
case Domain.AssetDepreciationType.AccountingBase:
{
return this.translate.instant('Res_ENUM_AssetDepreciationType_AccountingBase');}
default:
{
throw Error("Asset base not found");}
}
}
static DepreciationMethod(method: any): any{switch ((method)) {case Domain.AssetDepreciationMethod.Constant:
{
return this.translate.instant('Res_ENUM_AssetDepreciationMethod_Constant');}
case Domain.AssetDepreciationMethod.Decreasing:
{
return this.translate.instant('Res_ENUM_AssetDepreciationMethod_Decreasing');}
case Domain.AssetDepreciationMethod.Total:
{
return this.translate.instant('Res_ENUM_AssetDepreciationMethod_Total');}
default:
{
throw Error("Depreciation method not found");}
}
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.AssetDepreciationTranslationsKey == null || $this.AssetDepreciationTranslationsKey == 0;
            }


}